export default __webpack_public_path__ + "static/media/jonathan_king.e2691602.jpg";